enum CsvDataType {
	STRING = 'STRING',
	NUMBER = 'NUMBER',
	BOOLEAN = 'BOOLEAN',
	DATE = 'DATE',
}

type CsvColumn = {
	name: string
	field?: string
	type: CsvDataType
	isMissing: boolean
	isRequired: boolean
	description?: string
}

export type { CsvColumn }
export { CsvDataType }
